import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiCollectionsService } from '../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../services/alerts.service';
import { CollectionLight } from '../../../../models/collections/collection-light.model';

@Component({
  selector: 'app-collection-period-add-modal',
  templateUrl: './collection-period-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class CollectionPeriodAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  name: string = '';
  collectionId: number | null = null;
  startDate: string = '';
  endDate: string = '';
  collections: CollectionLight[] = [];

  private callbackSaved?: () => void;

  constructor(private apiCollectionsService: ApiCollectionsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.collections = [];
    this.apiCollectionsService.getAllCollections().then(
      response => { this.collections = response.results; },
      error => { this.alertsService.displayAlertError('Error loading collections : ' + error); }
    );
    this.name = '';
    this.collectionId = null;
    this.startDate = '';
    this.endDate = '';
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    this.apiCollectionsService.addCollectionPeriod(this.collectionId, this.name, startTimestamp, endTimestamp).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Period added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding period : ' + error);
      }
    );
  }
}
